import React from "react";
import { NavLink } from "react-router-dom";
import Translator from "Languages/Utility/Translator";
import { ReactSVG } from "react-svg";

function TopMenu({ menuItems, wrap }) {
  const handleClick = (e, item) => {
    if (!item.active) e.preventDefault();
  };

  return (
    <div className="topMenu">
      <ul className={`mb-0 navbar-top ${wrap ? 'wraping' : ''}`}>
        {menuItems.sort((a,b) => a.id - b.id).map((item) => {
          return (
            <NavLink
              onClick={(e) => handleClick(e, item)}
              key={item.path}
              exact
              activeClassName="itemActive"
              to={item.path}
            >
              <li>
                <ReactSVG src={item.menu_icon} />
                <Translator id={item.menu_title} />
              </li>
            </NavLink>
          );
        })}
      </ul>
    </div>
  );
}

export default TopMenu;
